import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { Link, withRouter } from 'react-router-dom';
import { reduxForm, Fields } from 'redux-form/immutable';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Typography } from '@mui/material';

import { useInjectEpics } from 'utils/injectEpics';
import { useInjectReducer } from 'utils/injectReducer';
import FormPasswordField from 'retired/FormPasswordField';
import SplashWrapper from 'retired/SplashWrapper';

import { selectSubmitDone, selectErrorCode, selectSuccess } from './selector';
import * as Actions from './actions';
import epics from './epics';
import reducer from './reducer';

const key = 'resetPassword';

const RenderFields = ({ submitDone, success, ...fields }) => (
  <div>
    <Fields
      names={['password1', 'password2']}
      component={FormPasswordField}
      errorText="Password fields must match."
      firstFieldProps={{
        name: 'password1',
        label: 'New Password',
      }}
      secondFieldProps={{
        name: 'password2',
        label: 'Confirm Password',
      }}
    />
    <br />
    <Button
      type="submit"
      color="primary"
      variant="contained"
      disabled={!(!submitDone && fields.password1.meta.valid && fields.password2.meta.valid)}
      style={{ width: '100%' }}
    >
      Submit
    </Button>
  </div>
);
RenderFields.propTypes = {
  submitDone: PropTypes.bool,
  success: PropTypes.bool,
};

const ResetPassword = (props) => {
  const { match, actions, handleSubmit, submitDone, errorCode, success } = props;
  const { token } = match.params;

  useInjectReducer({ key, reducer });
  useInjectEpics({ key, epics });
  useEffect(() => {
    actions.initAction();
  }, []);

  const submit = (data) => actions.submitAction(token, data.get('password1'));
  const errorMessages = {
    submitFailed:
      'The password-reset link sent to you may have expired. Please try again. We will now direct you back to the forgot password page.',
  };

  const successMessages = { default: 'Please log in with your new password.' };

  const newPassword = window.location.pathname.includes('/password/');

  return (
    <SplashWrapper>
      <Helmet title={newPassword ? 'Set Password' : 'Reset Password'} />
      <Typography variant="h1" mb={5}>
        {newPassword ? 'Set your password' : 'Reset your password'}
      </Typography>
      <form onSubmit={handleSubmit(submit)}>
        <Fields
          names={['password1', 'password2']}
          component={RenderFields}
          submitDone={submitDone}
        />
        <Dialog open={submitDone}>
          <DialogTitle style={{ textAlign: 'center' }}>
            {success ? 'Submission completed!' : 'Submission Failed!'}
          </DialogTitle>
          <DialogContent>
            {success ? successMessages.default : errorMessages[errorCode]}
          </DialogContent>
          <DialogActions>
            {success ? (
              <Link to="/login">
                <Button onClick={actions.resetDialogAction} color="primary" variant="contained">
                  OK
                </Button>
              </Link>
            ) : (
              <Link to="/forgot">
                <Button onClick={actions.resetDialogAction} color="primary" variant="contained">
                  Go Back
                </Button>
              </Link>
            )}
          </DialogActions>
        </Dialog>
      </form>
    </SplashWrapper>
  );
};

ResetPassword.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitDone: PropTypes.bool,
  errorCode: PropTypes.string,
  success: PropTypes.bool,
};

const withConnect = connect(
  (state) => ({
    submitDone: selectSubmitDone(state),
    success: selectSuccess(state),
    errorCode: selectErrorCode(state),
  }),
  (dispatch) => ({ actions: bindActionCreators(Actions, dispatch) })
);

const withForm = reduxForm({
  form: 'reset',
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
});

export default compose(withRouter, withConnect, withForm)(ResetPassword);
